module.exports = __webpack_public_path__ + "img/book-2-line.077fb60e.svg";